import React, { useEffect, useState } from "react";
import "./AfterPhaseQuestionnaire.css";
import { DEBUG_MODE } from "../../config/appConfig";
import Button from "@mui/material/Button";
import { getDebugAfterPhaseQuestionnaireData } from "../../utils/debugPrefill";

const AfterPhaseQuestionnaire = ({ handleFormSubmission, debugPrefill = false }) => {
  const scaleLabels = [
    "Not at all",
    "Mostly not",
    "Slightly not",
    "Neutral or unsure",
    "Slightly",
    "Mostly",
    "Very much",
  ];

  const [validationError, setValidationError] = useState("");
  const [formData, setFormData] = useState({
    tpa: {
      deceptive: "",
      underhanded: "",
      suspicious: "",
      wary: "",
      harmful: "",
      confident: "",
      security: "",
      integrity: "",
      dependable: "",
      reliable: "",
      trust: "",
      familiar: "",
    },
  });

  useEffect(() => {
    if (debugPrefill) {
      setFormData(getDebugAfterPhaseQuestionnaireData());
      setValidationError("");
    }
  }, [debugPrefill]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      tpa: {
        ...prev.tpa,
        [field]: value,
      },
    }));
  };

  const validateForm = () => {
    return Object.values(formData.tpa).every((value) => value !== "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setValidationError("");
      console.log("Form submitted:", formData);
      handleFormSubmission(formData);
    } else {
      setValidationError(
        "Please fill in all required fields before submitting the form."
      );
    }
  };

  const fillDebugData = () => {
    setFormData(getDebugAfterPhaseQuestionnaireData());
  };

  return (
    <div className="root-container">
      <div className="app">
        <div className="after-phase-questionnaire">
          <h1>Tell Us How The Photobook AI Felt To Use</h1>

          {DEBUG_MODE && (
            <Button
              variant="outlined"
              color="warning"
              onClick={fillDebugData}
              sx={{ marginBottom: 2 }}
            >
              🔧 Debug: Fill All Fields
            </Button>
          )}

          <form onSubmit={handleSubmit}>
            <section className="question-section">
              <h2>Your Trust In The Photobook AI *</h2>

              <div className="section">
                <p className="scale-info">
                  Please indicate how much each statement matched your experience in this trip.
                </p>

                <table className="likert-table">
                  <thead>
                    <tr>
                      <th></th>
                      {scaleLabels.map((label) => (
                        <th key={label}>{label}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { field: "deceptive", text: "The Photobook AI felt deceptive." },
                      { field: "underhanded", text: "The Photobook AI behaved in a way that felt deceitful." },
                      { field: "suspicious", text: "I felt suspicious of the Photobook AI's captions or explanations." },
                      { field: "wary", text: "I felt wary of relying on the Photobook AI." },
                      { field: "harmful", text: "The Photobook AI could lead to a harmful or misleading outcome." },
                      { field: "confident", text: "I felt confident using the Photobook AI." },
                      { field: "security", text: "The Photobook AI made me feel secure in my decisions." },
                      { field: "integrity", text: "The Photobook AI has integrity." },
                      { field: "dependable", text: "The Photobook AI felt dependable." },
                      { field: "reliable", text: "The Photobook AI felt reliable." },
                      { field: "trust", text: "I could trust the Photobook AI." },
                      { field: "familiar", text: "The Photobook AI felt familiar or easy to understand." },
                    ].map((question, index) => (
                      <tr key={question.field}>
                        <td>
                          {index + 1}. {question.text}
                        </td>
                        {scaleLabels.map((label, labelIndex) => {
                          const value = (labelIndex + 1).toString();
                          return (
                          <td key={value}>
                            <input
                              type="radio"
                              name={question.field}
                              aria-label={`${question.text} ${label}`}
                              checked={formData.tpa[question.field] === value}
                              onChange={() =>
                                handleChange(question.field, value)
                              }
                              required
                            />
                          </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>

            {validationError && (
              <div className="validation-error">
                {validationError}
              </div>
            )}

            <button type="submit" className="submit-button">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AfterPhaseQuestionnaire;
